<script setup>
import { defineProps } from 'vue'

defineProps({
  classGrid: {
    type: String,
    required: false,
  },
})
</script>

<template>
  <div class="grid bg--light-gray p-30">
    <h3 class="info-base__title">
      <slot name="title" />
    </h3>

    <div ref="block" :class="['grid', classGrid]">
      <slot name="column" />
    </div>
  </div>
</template>
